import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { images } from '../../constants'
import { AppWrap, MotionWrap } from '../../wrapper'
import { client } from '../../client'
import './Footer.scss'

const Footer = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const onSubmit = (data) => {
    setLoading(true)

    const contact = {
      _type: 'contact',
      name: data.name,
      email: data.email,
      message: data.message,
    }

    client.create(contact).then(() => {
      setLoading(false)
      setIsFormSubmitted(true)
    })
  }

  return (
    <>
      <h2 className="head-text">Vamos tomar um café & conversar</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:patsferrer@hotmail.com" className="p-text">
            patsferrer@hotmail.com
          </a>
        </div>
        {/* <div className='app__footer-card'>
          <img src={images.mobile} alt="mobile" />
          <a href="tel:+55 (55) 55555-5555" className='p-text'>+55 (55) 5555-5555</a>
        </div> */}
      </div>

      {!isFormSubmitted ? (
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="app__footer-form app__flex"
        >
          <div className="form-field app__flex">
            <input
              {...register('name', { required: 'O nome é obrigatório' })}
              maxLength={50}
              className={`p-text ${errors.name ? 'input-error' : ''}`}
              type="text"
              placeholder="Seu nome"
            />
            {errors.name && (
              <span className="error-message">{errors.name.message}</span>
            )}
          </div>

          <div className="form-field app__flex">
            <input
              {...register('email', {
                required: 'O email é obrigatório',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Email inválido',
                },
              })}
              maxLength={100}
              className={`p-text ${errors.email ? 'input-error' : ''}`}
              type="email"
              placeholder="Seu E-mail"
            />
            {errors.email && (
              <span className="error-message">{errors.email.message}</span>
            )}
          </div>

          <div className="form-field">
            <textarea
              {...register('message', { required: 'A mensagem é obrigatória' })}
              className={`p-text ${errors.message ? 'input-error' : ''}`}
              placeholder="Sua mensagem"
              maxLength={500}
            />
            {errors.message && (
              <span className="error-message">{errors.message.message}</span>
            )}
          </div>

          <button type="submit" className="p-text">
            {loading ? 'Enviando...' : 'Enviar Mensagem'}
          </button>
        </form>
      ) : (
        <div>
          <h3 className="head-text">Obrigada por entrar em contato!</h3>
        </div>
      )}
    </>
  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contato',
  'app__whitebg'
)
